import { useState } from "react";
import { PauseCircle, PlayCircle, CalendarPlus, Users } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Card, inputCls, btnOutline, errMsg } from "./ui";

export function ContractControls({ org, onUpdated }) {
  const c = org.contract;
  const [end, setEnd] = useState(c?.end || "");
  const [licenses, setLicenses] = useState(c?.licenses || 1);
  const [reason, setReason] = useState("");
  if (!c) return <Card><p className="text-sm text-slate-500">No contract yet — it is created when an accepted quotation is paid or activated.</p></Card>;
  const act = async (action, extra = {}) => {
    if (reason.trim().length < 3) return toast.error("Enter a reason (saved in the audit log)");
    try {
      onUpdated((await api.post(`/admin/institutions/${org.id}/contract`, { action, reason, ...extra })).data);
      toast.success(`Contract ${action} applied`);
      setReason("");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Card data-testid="contract-controls">
      <p className="font-heading font-semibold text-[#0B2545]">Contract {c.ref} · <span className="capitalize">{c.status}</span> · {c.start} → {c.end} · {c.licenses} licenses</p>
      <input className={`${inputCls} mt-4`} placeholder="Reason for the change (required, saved in the audit log)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="cc-reason" />
      <div className="grid md:grid-cols-2 gap-3 mt-3">
        <div className="flex gap-2"><input type="date" className={inputCls} value={end} onChange={(e) => setEnd(e.target.value)} data-testid="cc-end" />
          <button type="button" className={btnOutline} onClick={() => act("extend", { end })} data-testid="cc-extend"><CalendarPlus className="w-4 h-4" /> Set end date</button></div>
        <div className="flex gap-2"><input type="number" min={1} className={inputCls} value={licenses} onChange={(e) => setLicenses(Number(e.target.value))} data-testid="cc-licenses" />
          <button type="button" className={btnOutline} onClick={() => act("licenses", { licenses })} data-testid="cc-set-licenses"><Users className="w-4 h-4" /> Set licenses</button></div>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        {c.status !== "suspended"
          ? <button type="button" className={`${btnOutline} text-red-600 border-red-200`} onClick={() => act("suspend")} data-testid="cc-suspend"><PauseCircle className="w-4 h-4" /> Suspend</button>
          : <button type="button" className={`${btnOutline} text-emerald-700 border-emerald-200`} onClick={() => act("reactivate")} data-testid="cc-reactivate"><PlayCircle className="w-4 h-4" /> Reactivate</button>}
      </div>
      <p className="text-xs text-slate-500 mt-3">Material price or term changes for the organization go through a revised or renewal quotation. These controls are your administrative overrides.</p>
    </Card>
  );
}
